import { render, staticRenderFns } from "./TemplateContainer.vue?vue&type=template&id=1a48f825&"
import script from "./TemplateContainer.vue?vue&type=script&lang=js&"
export * from "./TemplateContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports